import type { ChainDailyData, SwapperDailyData } from '../../../../types';

export type PropTypes = {
  loading: boolean;
  dailyData?: ChainDailyData[] | SwapperDailyData[];
};

export type ModalPropTypes = {
  open: boolean;
  onClose: () => void;
  dailyData: ChainDailyData[] | SwapperDailyData[];
};

export enum DailyChartTabs {
  Volume = 'volume',
  NumOfSwaps = 'count',
  NumOfEffectiveSwaps = 'countEffective',
  EffectiveVolume = 'volumeEffective',
}

/** The numeric metric fields a chart tab can plot, picked from the daily-data shape. */
export type DailyChartMetric = Pick<
  SwapperDailyData,
  | DailyChartTabs.Volume
  | DailyChartTabs.NumOfSwaps
  | DailyChartTabs.NumOfEffectiveSwaps
  | DailyChartTabs.EffectiveVolume
>;
